import { Avatar, Box, Chip, Divider, Grid } from '@mui/material';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useGoogleLogin } from '@react-oauth/google';
import { Loading, LoginSignUpBox } from 'components';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { useSystemActions, useUserActions } from 'stores';
import { MotionWrapper } from 'utils';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

function TabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div hidden={value !== index} {...other}>
			<LoginSignUpBox value={value} />
		</div>
	);
}

const Login = () => {
	const [value, setValue] = useState(0);
	const { t } = useTranslation();
	const [searchParams] = useSearchParams();
	const { getImage, isWeChat } = useSystemActions();
	const { userGoogleLogin, userWeChatLogin } = useUserActions();
	const wxCode = searchParams.get('code');

	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};

	const gLogin = useGoogleLogin({
		flow: 'auth-code',
		onSuccess: async (tokenResponse) => {
			await userGoogleLogin(tokenResponse.code);
		},
	});

	const wxLogin = () => {
		//https://developers.weixin.qq.com/doc/offiaccount/OA_Web_Apps/Wechat_webpage_authorization.html
		window.location.href =
			process.env.REACT_APP_WECHAT_OAUTH2 +
			`?appid=${process.env.REACT_APP_WECHAT_APPID}` +
			`&redirect_uri=${encodeURIComponent(
				window.location.origin + window.location.pathname
			)}` +
			`&response_type=code` +
			`&scope=snsapi_userinfo` +
			`&state=0` +
			`#wechat_redirect`;
	};

	useEffect(() => {
		if (!wxCode) return;
		userWeChatLogin(wxCode);
	}, []);

	if (wxCode) return <Loading content={t('wechat.login')} />;

	return (
		<>
			<MotionWrapper p={2} pt={0} spacing={0}>
				<Grid container>
					<Grid item container xs={12} justifyContent="center">
						<Box
							component="img"
							sx={{
								width: '75%',
							}}
							alt="login_icon"
							src={getImage('login_icon.png')}
						/>
					</Grid>
					<Grid item container xs={12} justifyContent="center">
						<Box sx={{ width: '100%' }}>
							<Tabs
								value={value}
								onChange={handleChange}
								centered
							>
								<Tab
									disableRipple
									label={t('form.login')}
									value={0}
									sx={{
										marginRight: '25px',
										fontSize: '1.1em',
									}}
								/>
								<Tab
									disableRipple
									label={t('form.register')}
									value={1}
									sx={{
										marginLeft: '25px',
										fontSize: '1.1em',
									}}
								/>
							</Tabs>
							<TabPanel value={value} index={0} />
							<TabPanel value={value} index={1} />
						</Box>
					</Grid>
				</Grid>
				<Divider>
					<Chip
						label="OR"
						sx={{
							backgroundColor: 'transparent',
							width: '50px',
							height: '50px',
							'& .MuiChip-label': {
								fontSize: 18,
								fontWeight: 'bold',
							},
						}}
					/>
				</Divider>
				<Grid container justifyContent="center">
					{isWeChat(true) ? (
						<Grid item>
							<Avatar
								onClick={() => wxLogin()}
								src={getImage('login_wechat_icon.png')}
								sx={{ width: '50px', height: '50px' }}
							/>
						</Grid>
					) : (
						<Grid item>
							<Avatar
								onClick={() => gLogin()}
								src={getImage('login_google_icon.png')}
								sx={{ width: '50px', height: '50px' }}
							/>
						</Grid>
					)}
				</Grid>
			</MotionWrapper>
		</>
	);
};

export default Login;
